export const americanToDecimal = (o) => 1 + (o > 0 ? o / 100 : 100 / Math.abs(o));
export const decimalToAmerican = (d) => (d >= 2 ? Math.round((d - 1) * 100) : -Math.round(100 / (d - 1)));
export const fmtOdds = (o) => (o > 0 ? `+${o}` : `${o}`);
export const pct = (p) => (p == null ? "—" : `${Math.round(p * 100)}%`);
export const fairOdds = (p) => { const q = Math.min(Math.max(p || 0.5, 0.02), 0.98); return Math.round(q >= 0.5 ? -100 * q / (1 - q) : 100 * (1 - q) / q); };
export const money = (n) => `$${Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export function parlayMath(legs, wager) {
  const decimal = legs.reduce((a, l) => a * americanToDecimal(l.odds), 1);
  const prob = legs.reduce((a, l) => a * (l.win_probability ?? 0.5), legs.length ? 1 : 0);
  const payout = wager * decimal;
  return { decimal, american: legs.length ? decimalToAmerican(decimal) : 0, prob, payout, profit: payout - wager };
}

export const SPORT_META = {
  football: { label: "Football", short: "NFL", color: "#F59E0B" },
  college_football: { label: "College Football", short: "NCAAF", color: "#FB923C" },
  basketball: { label: "Basketball", short: "NBA", color: "#EF4444" },
  college_basketball: { label: "College Basketball", short: "NCAAB", color: "#F472B6" },
  baseball: { label: "Baseball", short: "MLB", color: "#3B82F6" },
  soccer: { label: "Premier League", short: "EPL", color: "#10B981" },
  mls: { label: "MLS", short: "MLS", color: "#38BDF8" },
  laliga: { label: "La Liga", short: "LALIGA", color: "#F97316" },
  bundesliga: { label: "Bundesliga", short: "BUNDES", color: "#EF4444" },
  ligue1: { label: "Ligue 1", short: "LIGUE1", color: "#60A5FA" },
  seriea: { label: "Serie A", short: "SERIEA", color: "#22D3EE" },
  hockey: { label: "Hockey", short: "NHL", color: "#A5B4FC" },
  tennis: { label: "Tennis", short: "ATP", color: "#84CC16" },
  ufc: { label: "UFC", short: "UFC", color: "#DC2626" },
  wnba: { label: "WNBA", short: "WNBA", color: "#FB7185" },
  boxing: { label: "Boxing", short: "BOXING", color: "#F43F5E" },
  golf: { label: "Golf", short: "PGA", color: "#4ADE80" },
  cricket: { label: "Cricket", short: "IPL", color: "#FBBF24" },
  rugby: { label: "Rugby", short: "NRL", color: "#A3E635" },
  motorsport: { label: "Formula 1", short: "F1", color: "#E11D48" },
  esports: { label: "Esports", short: "ESPORTS", color: "#A78BFA" },
  nascar: { label: "NASCAR", short: "NASCAR", color: "#FDBA74" },
  horse_racing: { label: "Horse Racing", short: "HORSES", color: "#06B6D4" },
};

export const TIER_LIMITS = {
  free: { maxLegs: 0, optMaxLegs: 0 },
  basic: { maxLegs: 4, optMaxLegs: 3 },
  premium: { maxLegs: 12, optMaxLegs: 10 },
};

export function stakeSuggestion(bankroll, decimal, prob) {
  if (!bankroll?.amount || !decimal || decimal <= 1 || prob == null) return null;
  const b = decimal - 1;
  if (bankroll.method === "flat") {
    const unit = bankroll.amount * ((bankroll.unit_pct || 1) / 100);
    const units = Math.min(3, Math.max(0.5, Math.round((0.5 + prob * 5) * 4) / 4));
    return { stake: unit * units, label: `${units}u × $${unit.toFixed(0)} unit`, method: "Flat units", edge: prob * decimal - 1 };
  }
  const kelly = (b * prob - (1 - prob)) / b;
  const frac = Math.min(Math.max(kelly / 4, 0), 0.05);
  return { stake: bankroll.amount * frac, label: frac > 0 ? `¼ Kelly · ${(frac * 100).toFixed(1)}% of bankroll` : "No edge — pass", method: "Fractional Kelly", edge: prob * decimal - 1 };
}

export const CONF_STYLE = {
  high: "bg-emerald-500/15 text-emerald-400 border-emerald-500/40",
  medium: "bg-amber-500/15 text-amber-400 border-amber-500/40",
  low: "bg-slate-500/15 text-slate-300 border-slate-500/40",
};

export const TIER_STYLE = {
  free: "bg-slate-700/60 text-slate-300 border-slate-600",
  basic: "bg-cyan-500/15 text-cyan-300 border-cyan-500/40",
  premium: "bg-amber-500/15 text-amber-300 border-amber-500/40",
};

export const slateLabel = (dateStr) => (dateStr ? new Date(`${dateStr}T12:00:00`) : new Date()).toLocaleDateString(undefined, { weekday: "long", month: "long", day: "numeric" });
